/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileContentDto
 */
export interface FileContentDto {
    /**
     * File content as a base64 string
     * @type {string}
     * @memberof FileContentDto
     */
    fileContent?: string | null;
}

/**
 * Check if a given object implements the FileContentDto interface.
 */
export function instanceOfFileContentDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FileContentDtoFromJSON(json: any): FileContentDto {
    return FileContentDtoFromJSONTyped(json, false);
}

export function FileContentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileContentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileContent': !exists(json, 'fileContent') ? undefined : json['fileContent'],
    };
}

export function FileContentDtoToJSON(value?: FileContentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileContent': value.fileContent,
    };
}

